import './NotificationMessage.css';
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Notification } from '../../model/notification';
import { writeDB } from '../../model/store';
import { Icon } from '../Icon/Icon';

interface Props {
  notification: Notification;
}

export function NotificationMessage({ notification }: Props): JSX.Element | null {
  const [removing, setRemoving] = useState(false);
  const timeOutRef = useRef<NodeJS.Timeout | null>(null);

  function removeNotification(): void {
    setRemoving(true);
    setTimeout(() => {
      writeDB.table('notifications').delete(notification.id);
    }, 200);
  }

  function disableCloseAfter(): void {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
  }

  function enableCloseAfter(): void {
    timeOutRef.current = setTimeout(removeNotification, notification?.closeAfter);
  }

  useEffect(() => {
    if (notification?.closeAfter) {
      enableCloseAfter();
    }

    return () => {
      disableCloseAfter();
    };
  }, []);

  function getIconName(item: Notification): 'check--sm' | 'alert-circle--sm' {
    switch (item.type) {
      case 'success':
        return 'check--sm';
      default:
        return 'alert-circle--sm';
    }
  }

  return (
    <div
      key={notification.id}
      className={classnames('notification', `notification--${notification.type}`, {
        'notification--exit': removing,
      })}
      onMouseEnter={disableCloseAfter}
      onMouseLeave={enableCloseAfter}
    >
      <div className="notification__icon">
        <Icon name={getIconName(notification)} />
      </div>
      <div className="notification__body">
        <header className="notification__header">
          <strong className="notification__title">{notification.title}</strong>
          <Icon className="notification__remove" onClick={removeNotification} name="remove" />
        </header>
        <div className="notification__description-wrapper">
          {notification.type === 'error' && <pre className="notification__description">{notification.message}</pre>}
          {notification.type !== 'error' && <div className="notification__description">{notification.message}</div>}
        </div>
      </div>
    </div>
  );
}
